
export function isLoggedIn(authContext) {
  return (authContext.get('session').get('principalName') !== 'anonymous');
}

export function hasRole(authContext, role) {
  return (authContext.get('session').get('roles').indexOf(role) !== -1);
}